import { isPartner, isDropService, isAdmin } from '@helpers';
import { createSelector } from '@reduxjs/toolkit';

export const isAuthenticated = createSelector([s => s], s => !!s.auth.token);
export const isAdminSelector = createSelector([s => s], s => isAdmin(s.auth.profile));
export const isPartnerSelector = createSelector([s => s], s => isPartner(s.auth.profile));
export const isApprovedPartnerSelector = createSelector([s => s], s => isPartner(s.auth.profile, true));
export const isDropServiceSelector = createSelector([s => s], s => isDropService(s.auth.profile));
export const langSelector = createSelector([s => s], s => s.auth.profile?.language || 'en');
